import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createStyles, rem } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function getVariantStyles(theme, _ref, variant) {
  var orientation = _ref.orientation,
      color = _ref.color,
      radius = _ref.radius,
      inverted = _ref.inverted,
      placement = _ref.placement;
  var vertical = orientation === "vertical";
  var filledScheme = theme.fn.variant({
    color: color,
    variant: "filled"
  });
  var radiusValue = rem(theme.fn.radius(radius));
  var borderRadius = orientation === "vertical" ? placement === "left" ? "".concat(radiusValue, " 0 0 ").concat(radiusValue) : " 0 ".concat(radiusValue, " ").concat(radiusValue, " 0") : inverted ? "0 0 ".concat(radiusValue, " ").concat(radiusValue) : "".concat(radiusValue, " ").concat(radiusValue, " 0 0");

  if (variant === "default") {
    var _spreadValues;

    return __spreadProps(__spreadValues((_spreadValues = {}, _defineProperty(_spreadValues, vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom", "".concat(rem(2), " solid transparent")), _defineProperty(_spreadValues, vertical ? placement === "left" ? "marginRight" : "marginLeft" : inverted ? "marginTop" : "marginBottom", rem(-2)), _defineProperty(_spreadValues, "borderRadius", borderRadius), _spreadValues), theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    })), {
      "&[data-active]": __spreadValues({
        borderColor: filledScheme.background,
        color: theme.colorScheme === "dark" ? theme.white : theme.black
      }, theme.fn.hover({
        borderColor: filledScheme.background
      }))
    });
  }

  if (variant === "outline") {
    var _before, _ref2;

    return _ref2 = {
      borderRadius: borderRadius,
      border: "".concat(rem(1), " solid transparent")
    }, _defineProperty(_ref2, vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom", "none"), _defineProperty(_ref2, "&[data-active]", {
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
      "&::before": (_before = {
        content: '""',
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        position: "absolute",
        bottom: vertical ? 0 : inverted ? "unset" : rem(-1),
        top: vertical ? 0 : inverted ? rem(-1) : "unset"
      }, _defineProperty(_before, vertical ? "width" : "height", rem(1)), _defineProperty(_before, "right", vertical ? placement === "left" ? rem(-1) : "unset" : 0), _defineProperty(_before, "left", vertical ? placement === "left" ? "unset" : rem(-1) : 0), _before)
    }), _ref2;
  }

  if (variant === "pills") {
    return __spreadProps(__spreadValues({
      borderRadius: theme.fn.radius(radius)
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    })), {
      "&[data-active]": __spreadValues({
        backgroundColor: filledScheme.background,
        color: theme.white
      }, theme.fn.hover({
        backgroundColor: filledScheme.background
      }))
    });
  }

  return {};
}

var useStyles = createStyles(function (theme, params, _ref3) {
  var variant = _ref3.variant;
  return {
    tabLabel: {},
    tab: __spreadValues({
      position: "relative",
      padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.md),
      paddingLeft: params.withIcon ? theme.spacing.xs : void 0,
      paddingRight: params.withRightSection ? theme.spacing.xs : void 0,
      fontSize: theme.fontSizes.sm,
      whiteSpace: "nowrap",
      zIndex: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: params.orientation === "horizontal" ? "center" : void 0,
      lineHeight: 1,
      "&:disabled": __spreadValues({
        opacity: 0.5,
        cursor: "not-allowed"
      }, theme.fn.hover({
        backgroundColor: "transparent"
      })),
      "&:focus": {
        zIndex: 1
      }
    }, getVariantStyles(theme, params, variant)),
    tabRightSection: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:not(:only-child)": {
        marginLeft: rem(7)
      }
    },
    tabIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:not(:only-child)": {
        marginRight: rem(7)
      }
    }
  };
});
export default useStyles;